import { Link } from "react-router-dom";
import { FaGraduationCap } from "react-icons/fa";

import { useConfraternizationDrink } from "../../providers/confraternization";
import { useGraduationDrink } from "../../providers/graduation";
import { useMarriageDrink } from "../../providers/marriage";

import {
  Container,
  Content,
  IconConfraternization,
  IconMarriage,
} from "./styles";

export const Header = ({ children, ...rest }) => {
  const { confraternizationDrink } = useConfraternizationDrink();
  const { graduationDrink } = useGraduationDrink();
  const { marriageDrink } = useMarriageDrink();

  return (
    <Container>
      <Content {...rest}>
        {children}
        <div>
          <Link to="/marriage">
            <IconMarriage />
          </Link>
          <Link to="/confraternization">
            <IconConfraternization />
          </Link>
          <Link to="/graduation">
            <FaGraduationCap />
          </Link>
          <div className="amount">
            {marriageDrink.length > 0 && (
              <span className="marriage">{marriageDrink.length}</span>
            )}
            {confraternizationDrink.length > 0 && (
              <span className="confraternization">
                {confraternizationDrink.length}
              </span>
            )}
            {graduationDrink.length > 0 && (
              <span className="graduation">{graduationDrink.length}</span>
            )}
          </div>
        </div>
      </Content>
    </Container>
  );
};
